var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinland({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.752888C22.3139 0.75336 22.6743 0.886607 22.9401 1.1234C23.2059 1.36019 23.3555 1.68122 23.356 2.0161V19.7222C23.3555 20.0571 23.2059 20.3781 22.9401 20.6149C22.6743 20.8517 22.3139 20.985 21.938 20.9854H2.06201C1.6861 20.985 1.32572 20.8517 1.05991 20.6149C0.7941 20.3781 0.644523 20.0571 0.643994 19.7222V2.0161C0.644523 1.68122 0.7941 1.36019 1.05991 1.1234C1.32572 0.886607 1.6861 0.75336 2.06201 0.752888H21.938ZM21.938 0.179199H2.06201C1.5153 0.179671 0.991126 0.373361 0.604541 0.717742C0.217956 1.06212 0.000529505 1.52907 0 2.0161V19.7222C0.000529505 20.2092 0.217956 20.6762 0.604541 21.0206C0.991126 21.365 1.5153 21.5586 2.06201 21.5591H21.938C22.4845 21.5582 23.0084 21.3643 23.3949 21.02C23.7813 20.6758 23.9989 20.2091 24 19.7222V2.0161C23.9995 1.52907 23.782 1.06212 23.3955 0.717742C23.0089 0.373361 22.4847 0.179671 21.938 0.179199Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.75293H12.89V7.9526H23.3561V2.01614C23.3555 1.68127 23.206 1.36023 22.9401 1.12344C22.6743 0.886649 22.314 0.753401 21.938 0.75293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34395 0.75293H2.06197C1.68605 0.753401 1.32568 0.886649 1.05987 1.12344C0.794057 1.36023 0.644481 1.68127 0.643951 2.01614V7.9526H6.34395V0.75293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.89 20.9856H21.938C22.314 20.9852 22.6743 20.8519 22.9401 20.6151C23.206 20.3783 23.3555 20.0573 23.3561 19.7224V13.7842H12.89V20.9856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643951 13.7842V19.7224C0.644481 20.0573 0.794057 20.3783 1.05987 20.6151C1.32568 20.8519 1.68605 20.9852 2.06197 20.9856H6.34395V13.7842H0.643951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8899 0.75293H6.34395V7.95438H0.643951V13.784H6.34395V20.9855H12.8899V13.784H23.356V7.95438H12.8899V0.75293Z",
    fill: "#103882"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.179199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinland);
export default __webpack_public_path__ + "static/media/Finland.faec96f10bb91a4abd5d89100934376a.svg";
export { ForwardRef as ReactComponent };